import { MainComponent } from './main.component';

export const MainRoutes: Array<any> = [
  {
    path: 'main',
    component: MainComponent,
    canActivate: [],
  },
];



// WEBPACK FOOTER //
// ./src/app/components/dashboard/main/main.routes.ts